import store from '../../redux/store/store';

const authInterceptor = (config) => {
    const state = store.getState();
    return config;
}

export default authInterceptor;